import React from 'react';
import Icon from '../AppIcon';

const VisualizerProgress = ({ currentStep = 1, completedSteps = [], onStepClick }) => {
  const steps = [
    { id: 1, label: 'Floor Type', icon: 'Grid3x3' },
    { id: 2, label: 'Colors', icon: 'Palette' },
    { id: 3, label: 'Room', icon: 'Home' },
    { id: 4, label: 'Review', icon: 'CheckCircle' }
  ];

  const isStepCompleted = (stepId) => completedSteps?.includes(stepId);
  const isStepActive = (stepId) => stepId === currentStep;
  const isStepAccessible = (stepId) => stepId <= currentStep || isStepCompleted(stepId);

  const handleStepClick = (stepId) => {
    if (isStepAccessible(stepId) && onStepClick) {
      onStepClick(stepId);
    }
  };

  return (
    <div className="visualizer-progress">
      <div className="visualizer-progress-steps">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.id}>
            <button
              onClick={() => handleStepClick(step?.id)}
              disabled={!isStepAccessible(step?.id)}
              className={`
                visualizer-progress-step
                ${isStepActive(step?.id) ? 'visualizer-progress-step-active' : ''}
                ${isStepCompleted(step?.id) ? 'visualizer-progress-step-completed' : ''}
                ${!isStepAccessible(step?.id) ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
              `}
            >
              <div className="visualizer-progress-step-indicator">
                {isStepCompleted(step?.id) ? (
                  <Icon name="Check" size={20} />
                ) : (
                  <span>{step?.id}</span>
                )}
              </div>
              <div className="visualizer-progress-step-label hidden sm:block">
                {step?.label}
              </div>
            </button>

            {index < steps?.length - 1 && (
              <div
                className={`
                  visualizer-progress-connector
                  ${isStepCompleted(step?.id) ? 'visualizer-progress-step-completed' : ''}
                `}
              />
            )}
          </React.Fragment>
        ))}
      </div>
      <div className="sm:hidden flex justify-center mt-4 gap-2">
        {steps?.map((step) => (
          <div
            key={step?.id}
            className={`
              w-2 h-2 rounded-full transition-all duration-300
              ${isStepActive(step?.id) ? 'bg-primary w-8' : ''}
              ${isStepCompleted(step?.id) ? 'bg-success' : ''}
              ${!isStepActive(step?.id) && !isStepCompleted(step?.id) ? 'bg-border' : ''}
            `}
          />
        ))}
      </div>
    </div>
  );
};

export default VisualizerProgress;